/* eslint-disable complexity */
import { defineStore } from "pinia";
import {
    MeasurementUnitType,
    AboutYouStore,
} from "./aboutYou";
import { YourDetailsStore } from "./yourDetails";
import {
    aboutLifeStyleInformation, aboutLifeStyleInformationPartial, gender,
} from "../composables/aboutYou";
import { ValueOrUndefined } from "../utils";
import { PersonData } from "../entities/conditions";

export enum RelationshipToCustomer {
    Dependant = "dependant",
    Wife = "wife",
    Husband = "husband",
    CivilPartner = "civilPartner",
    Cohabitant = "cohabitant",
}

export type Address = {
    line1: null,
    line2: null,
    city: null,
    county: null,
    postcode: string,
}

export type AboutYouDependantStore = Omit<
    AboutYouStore &
    YourDetailsStore &
    {
        relationshipToCustomer: RelationshipToCustomer | null
    },
    "email" | "phone">

export const useDependantAboutYouStore = defineStore("dependantAboutYou", {
    state: () : AboutYouDependantStore => {
        return {
            title: null,
            forename: "",
            surname: "",
            dob: "",
            sex: null,
            maritalStatus: null,
            postcode: "",
            relationshipToCustomer: null,
            smoker: null,
            smokingStart: "",
            smokingEnd: "",
            cigarettes: null,
            cigarettesPerDay: null,
            cigars: null,
            cigarsPerDay: null,
            rollingTobacco: null,
            rollingTobaccoPerWeek: null,
            pipeTobacco: null,
            pipeTobaccoPerWeek: null,
            alcohol: null,
            heightFeet: null,
            heightInches: null,
            heightCentimetres: null,
            heightUnit: MeasurementUnitType.Imperial,
            weightStone: null,
            weightPounds: null,
            weightKg: null,
            weightUnit: MeasurementUnitType.Imperial,
            waistInches: null,
            waistCentimetres: null,
            waistUnit: MeasurementUnitType.Imperial,
            medical: null,
            selectedMedicalConditions: [],
            currentMedicalCondition: null,
            toggleAlcoholModal: false,
        };
    },
    getters: {
        getDependantInformation: (state) => {
            return {
                relationshipToCustomer: state.relationshipToCustomer,
                title: state.title,
                forename: state.forename,
                surname: state.surname,
                dob: state.dob,
                sex: state.sex ?? gender(state.title),
                maritalStatus: state.maritalStatus,
                address: {
                    line1: null,
                    line2: null,
                    city: null,
                    county: null,
                    postcode: state.postcode,
                },
                lifestyle: aboutLifeStyleInformation(state),
            };
        },
        getPartialDependantInformation: (state) => {
            return {
                lifestyle: aboutLifeStyleInformationPartial(state),
                relationshipToCustomer: ValueOrUndefined(state.relationshipToCustomer, null) || undefined,
                title: ValueOrUndefined(state.title, null) || undefined,
                forename: state.forename,
                surname: state.surname,
                dob: state.dob,
                sex: ValueOrUndefined(state.sex, null) || undefined,
                maritalStatus: ValueOrUndefined(state.maritalStatus, null) || undefined,
                address: {
                    line1: null,
                    line2: null,
                    city: null,
                    county: null,
                    postcode: state.postcode,
                },
            };
        },
        getPersonDataForMedical: (state): PersonData => ({
            dob: state.dob,
        }),
        getMedicalConditions: (state) => {
            return state.selectedMedicalConditions;
        },
    },
});
